/**
 * Check if an element with the given ID exists on the current page
 * @param {string} elementId - The ID of the element to check
 * @returns {boolean} - True if the element exists, false otherwise
 */
const elementExists = (elementId) => {
  if (typeof window === "undefined" || !elementId) {
    return false
  }

  return !!document.getElementById(elementId)
}

export default elementExists
